import React, { useState } from 'react'
import axios from "../../../../axios";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
export default function JoinNowbtn({ event }) {
  const navigate = useNavigate();

  const onJoinNowClick = async (e) => {
    e.stopPropagation();
    const data = JSON.parse(localStorage.getItem("breathForStudent"));
    let _id;
    event.Events.forEach((element) => {
      if (element.name === "bbb_lecture") {
        _id = element.value;
      }
    });
    try {
      const res = await axios.get(
        `/videoConference/classes/join/${_id}?viewer_name=${data?.name}&user_id=${data?.id}`
      );

      if (res.data.data) {
        const win = window.open(res.data.data, "_blank");
        if (win) win.focus();
      }
    } catch (error) {
      console.error("Join class error:", error);
      toast.error("Meeting is not started!!");
    }
  };
  return (
    <div>
      <div id="card_body_new">
        <button type="button" data-dismiss="modal" id='PopUpBtn_Sanskrt' class="btn btn" onClick={(e) => onJoinNowClick(e)}>JOIN NOW</button>

      </div>
    </div>
  )
}
